import type { MRT_ColumnDef } from "material-react-table";
import type { AdminCampaignDto } from "Infrastructure/Api/Api";
import { formatDate } from "Utils/DateUtils";
import { Resources, type TFunction } from "Translations/Resources";
import { Tooltip, Box, Typography } from "@mui/material";
import { CodeCell } from "Components/Admin/Campaigns/CampaignListTable/CodeCell";
import { NameCell } from "Components/Admin/Campaigns/CampaignListTable/NameCell";

const RESOURCES = Resources.Admin.Campaigns.Table;

export const createSharedCampaignColumns = (
  t: TFunction,
): Array<MRT_ColumnDef<AdminCampaignDto>> => [
  {
    accessorKey: "name",
    header: t(RESOURCES.CampaignName),
    size: 200,
    Cell: ({ row }) => (
      <NameCell
        name={row.original.name}
        code={row.original.code}
        color={row.original.color}
      />
    ),
  },
  {
    accessorKey: "code",
    header: t(RESOURCES.Code),
    size: 150,
    Cell: ({ row }) => (
      <CodeCell code={row.original.code} color={row.original.color} />
    ),
  },
  {
    accessorKey: "receiverUserID",
    header: t(RESOURCES.Receiver),
    size: 120,
    enableSorting: false,
    Cell: ({ row }) => {
      const merchantUser = row.original.receiverMerchantUser;
      const companyName = merchantUser?.companyName;
      const companyNumber = merchantUser?.companyNumber;

      return (
        <Tooltip
          title={
            companyNumber
              ? `IČO: ${companyNumber}`
              : t(RESOURCES.NoReceiverAssigned)
          }
          placement="top"
        >
          <Box component="span">
            <Typography variant="body2" noWrap>
              {companyName ? companyName : "—"}
            </Typography>
          </Box>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: "startDate",
    header: t(RESOURCES.StartDate),
    size: 170,
    filterVariant: "date",
    Cell: ({ row }) =>
      row.original.startDate ? (
        formatDate(row.original.startDate)
      ) : (
        <Typography variant="body2" color="text.secondary">
          {t(RESOURCES.Unlimited)}
        </Typography>
      ),
  },
  {
    accessorKey: "endDate",
    header: t(RESOURCES.EndDate),
    size: 170,
    filterVariant: "date",
    Cell: ({ row }) =>
      row.original.endDate ? (
        formatDate(row.original.endDate)
      ) : (
        <Typography variant="body2" color="text.secondary">
          {t(RESOURCES.Unlimited)}
        </Typography>
      ),
  },
  {
    accessorKey: "dateCreated",
    header: t(RESOURCES.Created),
    size: 170,
    filterVariant: "date",
    Cell: ({ row }) => formatDate(row.original.dateCreated),
  },
  //Commenting out for now, logic around will likely be changed in near future
  //   {
  //     accessorKey: "isAffiliateEnabled",
  //     header: t(RESOURCES.Affiliate),
  //     size: 100,
  //     Cell: ({ row }) => (
  //       <Chip
  //         label={
  //           row.original.isAffiliateEnabled
  //             ? t(RESOURCES.Enabled)
  //             : t(RESOURCES.Disabled)
  //         }
  //         size="small"
  //         color={row.original.isAffiliateEnabled ? "success" : "default"}
  //       />
  //     ),
  //   },
];
